export default {
    items: [],
    fields: [
        {
            key: "id",
            label: "#",
            sorter: false,
            filter: false,
            _style: "width:10%",
        },
        {
            key: "providerName",
            label: "provider",
            sorter: false,
            filter: false,
            _style: "width:20%",
        },
        {
            key: "origin",
            label: "origin",
            sorter: false,
            filter: false,
            _style: "width:20%",
        },
        {
            key: "email",
            label: "email",
            sorter: false,
            filter: false,
            _style: "width:40%",
        },
    ],
    order: "asc",
    rows: 5,
    page: 1,
    total_pages: 0,
    loading: true,
}